import { breakpoints } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const Wrapper = styled.div<{ hideOnMobile?: boolean }>`
  position: relative;
  overflow: hidden;
  display: ${({ hideOnMobile }) => (hideOnMobile ? 'none' : 'block')};

  @media (min-width: ${breakpoints.lg}) {
    display: block;
  }
`;

export const ImageWrapper = styled.div`
  flex-shrink: 0;
`;

export const ScrollWrapper = styled.div`
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;

  ::-webkit-scrollbar {
    display: none;
  }
`;

export const ScrollContent = styled.div<{
  gap?: string;
  isCentered?: boolean;
  scrollPadding?: string;
}>`
  display: flex;
  gap: ${({ gap }) => gap || '1rem'};
  width: fit-content;
  margin: ${({ isCentered }) => (isCentered ? '0 auto' : '0')};
  padding-inline: ${({ scrollPadding }) => scrollPadding || '0'};
`;
